import {
  string, number, object, oneOfType,
} from 'prop-types';
import { isNil } from 'ramda';

import { TIME_PATTERNS, timeFormatPattern } from './utils';

/**
 * Component that displays given timestamp as time in 'hh:mm:ss a' format
 * Can also receive children as render prop
 */

const formatters = {
  hh: (date, period) => `${period && date.getHours() > 12 ? date.getHours() % 12 : date.getHours()}`.padStart(2, '0'),
  mm: (date) => `${date.getMinutes()}`.padStart(2, '0'),
  ss: (date) => `${date.getSeconds()}`.padStart(2, '0'),
};

const getPeriod = (date) => (date.getHours() >= 12 ? 'PM' : 'AM');

const extractTimeWithPattern = (format, timestamp) => {
  const date = typeof timestamp === 'object'
    ? {
      getHours: () => timestamp.hours,
      getMinutes: () => timestamp.minutes,
      getSeconds: () => timestamp.seconds,
    }
    : new Date(timestamp);
  const period = format.includes(TIME_PATTERNS.PERIOD) ? getPeriod(date) : null;
  const sanitizedFormat = period ? format.split(' ')[0] : format;

  // extract time according to given format
  const timeArr = sanitizedFormat.split(':').map((part) => formatters[part](date, period));

  return timeArr.join(':') + (period ? period.padStart(3, ' ') : '');
};

function TimeFormat(props) {
  const { format, timestamp, time, milliseconds, children } = props;
  const timeDisplay = extractTimeWithPattern(format.toLowerCase(), isNil(time) ? timestamp : time);

  return isNil(children) ? timeDisplay : children({ timeDisplay, milliseconds });
}

TimeFormat.propTypes = {
  format: timeFormatPattern,
  milliseconds: number,
  timestamp: oneOfType([ string, number, object ]),
  time: object,
};

TimeFormat.defaultProps = {
  format: `${TIME_PATTERNS.HOURS}:${TIME_PATTERNS.MINUTES}:${TIME_PATTERNS.SECONDS}`,
  timestamp: Date.now(),
};

export default TimeFormat;
